import { useEffect } from 'react';
import { apiFetch } from './api.js';
import { DEFAULT_IDLE_TIMEOUT_MS } from './useAutoLogout.js';
import { getLastActivity, getLastPing, markPing } from './sessionActivity.js';

const HEARTBEAT_INTERVAL_MS = 60 * 1000;

// Touches the server session right away and records it, so no tab pings again straight after.
export function pingSession() {
  markPing();
  return apiFetch('/me').catch(() => {});
}

// Keeps the server-side session alive while the user clicks or types without that
// triggering real API calls (e.g. composing a long reply). Uses the same activity as
// useAutoLogout, so the server's idle clock matches the one the user sees. Pings at
// most once per interval across all tabs, and only when there was activity since the
// last ping.
export function useSessionHeartbeat(loginId, idleTimeoutMs = DEFAULT_IDLE_TIMEOUT_MS) {
  useEffect(() => {
    if (!loginId) return;

    // Well inside the timeout, so a short SessionTimeout still gets pinged in time.
    const intervalMs = Math.min(HEARTBEAT_INTERVAL_MS, idleTimeoutMs / 3);

    const intervalId = setInterval(() => {
      const lastPing = getLastPing();
      if (getLastActivity() > lastPing && Date.now() - lastPing >= intervalMs) {
        pingSession();
      }
    }, intervalMs);

    return () => clearInterval(intervalId);
  }, [loginId, idleTimeoutMs]);
}
